import React, { PureComponent, Fragment } from 'react'
import styles from './Creators.scss'
import animated from './animate.css'
import appUrl, { imageUrl } from '@libs/appUrl'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { Element } from 'react-scroll'
import $ from 'jquery'
import shuffle from 'lodash/shuffle'

export default class Creators extends PureComponent {
  sliderSettings = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: true,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 991,
        settings: {
          variableWidth: true,
          centerMode: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          focusOnSelect: true,
          arrows: false,
        },
      },
      {
        breakpoint: 720,
        settings: {
          variableWidth: true,
          centerMode: true,
          slidesToShow: 2,
          slidesToScroll: 2,
          focusOnSelect: true,
          arrows: false,
        },
      },
      {
        breakpoint: 576,
        settings: {
          variableWidth: true,
          centerMode: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          focusOnSelect: true,
          arrows: false,
          dots: false,
        },
      },
    ],
  }
  state = {
    userList: [],
  }
  componentDidMount() {
    this._getUserList()
  }
  _getUser = (mid) => {
    return new Promise((resolve) => {
      $.post('/api/user/get', { umid: mid }, resolve)
    })
  }
  _getUserList = async () => {
    const users = shuffle([
      '210492', //美裝
      '48619', //美裝
      '49272', //美裝
      '126357', //美裝
      '26298', // 發胖
      '141868', // 發胖
      '28131', // 何何 ｜hoho
      '284624', // 發胖
      '31327', // 邦妮子
      '183816', // 汀尼扣Nicole
      '280842', // 打卡
      '146158', // 打卡
      '127398', // 圖文
      '28032', // 生活
      '244382', // 生活
      '211756', // 生活
      '215142',
      '118237',
    ])
    const userList = await Promise.all(users.map(this._getUser))
    this.setState({ userList })
  }
  render() {
    return (
      <Fragment>
        <style jsx>{styles}</style>
        <style jsx>{animated}</style>
        <Element name="creators" />
        <div className="creators">
          <h2>精選創作者</h2>
          <Slider {...this.sliderSettings} className="slick">
            {this.state.userList.map((item) => {
              return (
                <div key={item.mid} className="box">
                  <a
                    href={`${appUrl.appUrl}/user/${item.mid}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="wrap">
                      <img src={`${imageUrl(item.img)}`} />
                      <div className="name">{item.name}</div>
                      <div className="script">{item.des}</div>
                    </div>
                  </a>
                </div>
              )
            })}
          </Slider>
        </div>
      </Fragment>
    )
  }
}
